export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";